import React, { useEffect, useState } from 'react';
import { Loader2, Search, FileText, Globe } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { api, errMsg } from '../api';
import { goldBtn, ghostBtn, inputCls } from '../ui';
import { Flag } from '../countries';

export default function ForeignLookup({ node, onClose, onPick }) {
  const [name, setName] = useState('');
  const [countries, setCountries] = useState('');
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (n = name, c = countries) => {
    setBusy(true);
    try {
      const { data } = await api.get('/cs/graph/find-company', { params: { name: n, countries: c } });
      setRes(data); setCountries(data.countries);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  useEffect(() => { if (node) { setName(node.label); setCountries(''); setRes(null); run(node.label, ''); } }, [node]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={!!node} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-[#E5E5E5] rounded-sm max-w-2xl" data-testid="graph-foreign-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Globe size={17} className="text-[#D4AF37]" />Cerca la società del gruppo</DialogTitle></DialogHeader>
        <p className="text-xs text-[#8A8F97]">La banca dati non collega questa società al grafo (succede spesso con le società estere). Cercala per nome nei Paesi indicati e richiedi il report: verrà aggiunta al grafo.</p>
        <form onSubmit={(e) => { e.preventDefault(); run(); }} className="grid sm:grid-cols-[1fr_180px_auto] gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} className={inputCls} data-testid="graph-foreign-name" />
          <Input value={countries} onChange={(e) => setCountries(e.target.value.toUpperCase())} placeholder="Paesi (es. NL,BE)" className={`${inputCls} font-mono`} data-testid="graph-foreign-countries" />
          <Button type="submit" disabled={busy} className={`${ghostBtn} h-10`} data-testid="graph-foreign-search">{busy ? <Loader2 size={15} className="animate-spin" /> : <><Search size={15} className="mr-2" />Cerca</>}</Button>
        </form>
        <div className="max-h-[340px] overflow-y-auto divide-y divide-[#1F242C] border border-[#1F242C]" data-testid="graph-foreign-results">
          {!res && busy && <p className="p-4 text-sm text-[#5A5F67]">Ricerca in corso…</p>}
          {res && res.companies.length === 0 && <p className="p-4 text-sm text-[#5A5F67]" data-testid="graph-foreign-empty">Nessuna società trovata. Prova a cambiare i Paesi o a togliere la forma giuridica dal nome.</p>}
          {res?.companies.map((c) => (
            <div key={c.id} className="p-3 flex items-center gap-3" data-testid={`graph-foreign-result-${c.id}`}>
              <Flag code={c.country} className="w-5 h-auto shrink-0" />
              <div className="flex-1 min-w-0"><p className="text-sm text-[#F2F2F2] truncate">{c.name}</p><p className="text-xs font-mono text-[#5A5F67] truncate">{c.id}{c.address ? ` · ${c.address}` : ''}</p></div>
              <Button onClick={() => onPick(c)} className={`${goldBtn} h-9`} data-testid={`graph-foreign-pick-${c.id}`}><FileText size={14} className="mr-2" />Richiedi report</Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
